
import { defineComponent, onMounted, reactive, toRefs, ref } from "vue";
import { StateType } from "./authentication";
import Throttle from "@/utils/throttle";
import { getAuthList } from "../../../../api/production";
import { ImagePreview } from "vant";
let throttle: Throttle;
const states = {
  screenHeight: 0,
  dataList: [],
  id: "",
  page: 1,
  swipe:[]
};
export default defineComponent({
  props: ["dataId", "card"],
  setup(prop, { emit, slots }) {
    const state = reactive<StateType>(states);
    const { getAuthData } = useDatas(state, emit);
    onMounted(() => {
      state.id = prop.dataId;
      state.page = 1;
      state.dataList = [];
      getAuthData();
      throttle = new Throttle(500, () => {
        state.page++;
        getAuthData();
      });
    });
    return {
      ...toRefs(state),
      ...useEvent(state), 
    };
  },
});
const useEvent = (state: StateType) => {
  const reg = /(-)/g;
  const getEl = (el:any)=>{
    state.swipe.push(el)
  }
  const swipeChange = () => {};
  const prev = (index:number,id:number) => {
    state.swipe[index].prev()
    state.dataList = state.dataList.map((item:any)=>{
      if(item.id == id){
        item.current = item.current == 0?item.current:item.current-1
      }
      return item
    })
    
  };
  const next = (index:number,id:number) => {
    state.swipe[index].next()
    state.dataList = state.dataList.map((item:any)=>{
      if(item.id == id){
        item.current = item.current == (item.newImgs.length -1)?item.current:item.current+1
      }
      return item
    })
  };
  const replaceTime = (time: string) => {
    return time.replace(/(\d+)-(\d+)-(\d+)/g, "$1年$2月$3日");
  };
  const onPreviewImg = (item: any, v: Array<any>) => {
    let temp = v.map((items: any) => {
      return items.url;
    });
    ImagePreview({
      images: temp,
      startPosition: item.tempIndex,
    });
  };
  const onBottom = () => {
    throttle.search(null);
  };
  return {
    getEl,
    swipeChange,
    prev,
    next,
    onBottom,
    onPreviewImg,
    replaceTime,
  };
};
const useDatas = (state: StateType, emit: any) => {
  const getAuthData = async () => {
    const result: any = await getAuthList({
      page: state.page,
      pageSize: 10,
      traceSourceId: state.id,
    });
    if (result.data.code == 0) {
      state.dataList = state.dataList.concat(result.data.data.records);
      // 手动给所有数据增加一个index 预览时使用
      state.dataList = state.dataList.map((item: any) => {
        item.newImgs = item.fileImgs.map((val: any, index: number) => {
          val.tempIndex = index;
          return val;
        });

        item.current = 0;
        return item;
      });
      state.dataList = state.dataList.sort((a: any, b: any) => {
        if (a.sort > b.sort) {
          return 1;
        } else if (a.sort < b.sort) {
          return -1;
        } else {
          return 0;
        }
      });
    }
  };
  return {
    getAuthData,
  };
};
